export const statusList = ['OFF', 'ON', 'NORMAL', 'WARNING', 'DANGER'];

export const checkStatus = (
  currentStatus,
  currentMessage,
  nextStatus,
  nextMessage,
) => {
  if (statusList.indexOf(nextStatus) > statusList.indexOf(currentStatus))
    return [nextStatus, nextMessage];
  return [currentStatus, currentMessage];
};

export const isNextStatusWorseOrSame = (currentStatus, nextStatus) => {
  return statusList.indexOf(nextStatus) >= statusList.indexOf(currentStatus);
};

export const isAlert = nextStatus => {
  return nextStatus === 'WARNING' || nextStatus === 'DANGER';
};
